import React, { useState, useEffect, useContext } from 'react';
import '../TemplateDashboard/Template.scss';
import { Breadcrumb } from 'react-bootstrap';
import Axios from 'utility/Axios';
import configURL from 'config/config';
import Skeleton from 'components/Skeleton';
import Pagination from "react-js-pagination";
import AppContext from 'store/AppContext';
import EditCategoryModel from 'components/EditCategoryModel';
import { toast } from 'react-toastify';
import { confirmAlert } from "react-confirm-alert";
import  { useNavigate, useLocation } from "react-router-dom";

const TemplateCategory = (props) => {
    const location = useLocation();
    const { languageObj = {} } = useContext(AppContext)
    const [catCards, setCatCards] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState(false);
    const [perPage] = useState((location.state.action === "edit-one") ? 8 : 7);
    const [categoryEditMeta, setCategoryEditMeta] = useState({
        visible: false,
        data: null
    });

    const navigate = useNavigate();

    const handleDeleteCategory = (e, id) => {
        let formData = new FormData();
        formData.append("id", id)
        confirmAlert({
            title: 'Delete Category',
            message: "All the templated and themes linked to this category will be deleted ? ",
            buttons: [
                {
                    label: 'Confirm',
                    onClick: () => {
                        Axios.post(configURL.delete_category, formData).then(response => {
                            if (response.data.success === true) {
                                toast.success(response.data.message || "Category Deleted!")
                                categoryListing()
                            } else {
                                toast.warn(response.data.message)
                            }
                        })
                    }
                },
                {
                    label: 'Cancel',

                }
            ]
        });
    }

    const categoryListing = (page = 1) => {
        setLoading(true);
        let formData = new FormData();
        formData.append("page", page);
        formData.append("per_page", perPage);
        formData.append("type", "template");
        Axios.post(configURL.partner_categoryListing, formData).then(res => {
            if (res.data.success !== undefined && res.data.success) {
                setCatCards(res.data.data);
                setPagination(res.data.pagination)
                setLoading(false);
            }
        })
    }

    const handlePaginate = (page = 1) => {
        categoryListing(page)
    }

    useEffect(categoryListing, []);

    return (
        <React.Fragment>
            <section className="Page-SurveyCategory">
                <EditCategoryModel visible={categoryEditMeta.visible} categoryData={categoryEditMeta.data} onHide={() => {
                    setCategoryEditMeta({ ...categoryEditMeta, visible: false, data: null })
                }} updateList={categoryListing} />
                <div className="breadcrumb_ezi">
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={() => navigate("/template-dashboard")}>
                            {languageObj.translate('Template.1')}
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>{languageObj.translate('TemplateCategories.1')}</Breadcrumb.Item>
                    </Breadcrumb>
                    <div className="column-header">
                        <h1 className="page-heading">{languageObj.translate('Categories.1')}</h1>
                    </div>
                </div>
                <div className="survey_card_c-wrap">
                    {
                        (location.state.action === "create-new") && <div className="survey_card_c" onClick={() => {
                            navigate('/template-dashboard/add-category');
                        }}>
                            <span className="survey_card_add_ic"></span>
                            <label className="survey_card_add-label">{languageObj.translate('CreateNew.1')}</label>
                            <p className="survey_card_c-des">{languageObj.translate('Categories.1')}</p>
                        </div>
                    }
                    {loading
                        ?
                        <Skeleton value={perPage} />
                        :
                        catCards.map((item, index) => (
                            <div className="survey_card_c" key={item.id} onClick={() => {
                                if (location.state.action === "edit-one") {
                                    navigate('/template-dashboard/category-templates', {
                                        state:{category_id: item.id,
                                        category_name: item.category_name}
                                    });
                                }
                                else {
                                    navigate(`/template-dashboard/add-new/${item.id}`, {
                                        state:{action: "create-template",
                                        category_name: item.category_name}
                                    });
                                }
                            }}>
                                <div className="category-icon-wrapper">
                                    <span className={`category-edit_ic`} onClick={(e) => {
                                        e.stopPropagation()
                                        setCategoryEditMeta({ ...categoryEditMeta, visible: true, data: item })
                                    }}></span>
                                    <span className={`category-delte_ic`} onClick={(e) => {
                                        e.stopPropagation()
                                        handleDeleteCategory(e, item.id)
                                    }}></span>
                                </div>
                                <label className="survey_card_c-label">{item.category_name}</label>
                                <p className="survey_card_c-des">{item.description}</p>
                            </div>
                        ))
                    }
                </div>
                {(pagination && pagination.total > perPage) && <div className="pagination-plugin-wrap">
                    <Pagination
                        activePage={pagination.current_page}
                        itemsCountPerPage={perPage}
                        totalItemsCount={pagination.total}
                        onChange={handlePaginate}
                        hideDisabled={true}
                    />
                </div>}
            </section>
        </React.Fragment>
    )
}

export default TemplateCategory;